import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconKeyboardArrowLeftLine = ({
  width,
  height,
  fill = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.454 12 4.073 4.073c.138.139.21.313.213.522a.707.707 0 0 1-.213.532.718.718 0 0 1-.527.217.718.718 0 0 1-.527-.217l-4.494-4.494A.832.832 0 0 1 8.723 12a.831.831 0 0 1 .256-.633l4.494-4.494a.726.726 0 0 1 .522-.213.708.708 0 0 1 .532.213c.145.145.217.32.217.527a.718.718 0 0 1-.217.527L10.454 12Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardArrowLeftLine;
